import { useEffect, useState } from 'react'
import {
  AgxColumn,
  SurveyPlanUploadModel,
  AgxControlledCheckbox,
  DocumentTypes,
  Images,
  AgxFileUpload,
} from '@urbanx/agx-ui-components'

interface Props {
  id: string
  label?: string
  multiple?: boolean
  extensions?: string[]
  documentType?: DocumentTypes
  isSortable?: boolean
  campaignId: string
  onChange: (change: {
    id: string
    value: SurveyPlanUploadModel
  }) => void
  defaultValue?: SurveyPlanUploadModel
  getAuthToken: () => Promise<string | void>
  uploadFile?: (...args: any) => Promise<any>
  deleteFile?: (
    authToken: string,
    filePath: string
  ) => Promise<number | undefined>
  getFileLink?: (authToken: string, filePath: string) => Promise<any>
  required: boolean
  validate: boolean
}

const SurveyPlanUpload = ({
  id,
  label,
  defaultValue,
  getAuthToken,
  campaignId,
  onChange,
  uploadFile,
  deleteFile,
  getFileLink,
  required,
  validate,
  multiple = false,
  isSortable = false,
  extensions = ['pdf'],
  documentType = DocumentTypes.SurveyPlan,
}: Props) => {
  const [surveyPlansAttachedToSellerDisclosure, setSurveyPlansAttachedToSellerDisclosure] = useState(
    defaultValue?.surveyPlansAttachedToSellerDisclosure ?? false
  )

  const [surveyPlans, setSurveyPlans] = useState(
    defaultValue?.surveyPlans
  )

  useEffect(() => {
    onChange({
      id,
      value: {
        surveyPlansAttachedToSellerDisclosure: surveyPlansAttachedToSellerDisclosure,
        surveyPlans: surveyPlans,
      },
    })
  }, [surveyPlansAttachedToSellerDisclosure, surveyPlans])

  return (
    <AgxColumn extraLargeGap>
      <AgxFileUpload
        id={`surveyPlanUpload-${id}`}
        key={`surveyPlanUpload-${id}-${surveyPlansAttachedToSellerDisclosure}`}
        dataTestId={`survey-plan-upload-${id}`}
        title={label}
        documentType={documentType}
        fill
        extensions={extensions}
        multiple={multiple}
        isSortable={isSortable}
        fileData={
          surveyPlans
        }
        onValueChanged={({ value: uploadedFiles }) => setSurveyPlans(uploadedFiles)}
        getAuthToken={getAuthToken}
        campaignId={campaignId}
        uploadFile={uploadFile}
        deleteFile={deleteFile}
        getFileLink={getFileLink}
        required={!surveyPlansAttachedToSellerDisclosure && required}
        validate={validate}
        uploadButtonIcon={<Images.CloudUpload />}
      />
      <AgxControlledCheckbox
        key={`surveyPlansAttachedToSellerDisclosure-${id}`}
        checked={surveyPlansAttachedToSellerDisclosure}
        onValueChanged={(value) => setSurveyPlansAttachedToSellerDisclosure(value)}
        label="Attached to Seller Disclosure"
        naked
        id={id}
      />
    </AgxColumn>
  )
}

export default SurveyPlanUpload
